import { googleLogout as signOut, useGoogleLogin } from '@react-oauth/google';
import classNames from 'classnames';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

// Nova forma de logar com o Google
// https://livefiredev.com/in-depth-guide-sign-in-with-google-in-a-react-js-application/

const animationEnter = 'animate__animated animate__bounceIn animate__delay-1s';
const animationButton =
  'animate__animated animate__pulse animate__faster animate__delay-1s';
const delay1 = '0.8s';
const delay2 = '0.85s';
const service = 'google';

function OAuthGoogleButtonContent({
  // loaded,
  logo,
  analytics,
  accountAPI,
  onLoggedIn,
  onErrorMessage,
  children,
}) {
  const { analyticsFeatureUseEvent } = analytics ?? (() => {});
  const [googleFail, setGoogleFail] = useState(false);
  const [loading, setLoading] = useState(false);
  const { googleSigninFromRemote } = accountAPI ?? (() => {});
  const classes = useStyles();
  const { t } = useTranslation();
  const failureMessage = t('oauth.google.error');

  useEffect(() => {
    signOut();
  }, [signOut]);

  const onLoginSuccess = async (googleResponse) => {
    const accessToken = googleResponse.access_token;

    try {
      const response = await googleSigninFromRemote(accessToken);
      await onLoggedIn?.call(this, response.data, service);
    } catch (error) {
      if (error.response?.status === 422) {
        const validation = _.head(error.response?.data);
        onErrorMessage?.call(this, validation.message, service);
      } else {
        onErrorMessage?.call(this, failureMessage, service);
      }
    }

    setLoading(false);
  };

  const onLoginFailure = (response) => {
    if (response?.error !== 'popup_closed_by_user') {
      setGoogleFail(true);
      onErrorMessage?.call(this, failureMessage, service);
      console.warn(response);
    } else {
      onErrorMessage?.call(this, t('oauth.google.login-canceled'), service);
      console.error(response);
    }

    setLoading(false);
  };

  const onNonLoginFailure = (error) => {
    if (error.type === 'popup_closed') {
      onErrorMessage?.call(this, t('oauth.google.login-canceled'), service);
      console.error(error);
    } else {
      setGoogleFail(true);
      onErrorMessage?.call(this, failureMessage, service);
      console.error(error);
    }

    setLoading(false);
  };

  const signIn = useGoogleLogin({
    onSuccess: onLoginSuccess,
    onError: onLoginFailure,
    onNonOAuthError: onNonLoginFailure,
    scope: 'profile email',
  });

  const onClick = () => {
    analyticsFeatureUseEvent('auth google click');
    onErrorMessage?.call(this, null, service);
    setLoading(true);

    _.delay(() => {
      signIn();
    }, 800);
  };

  return (
    <Button
      style={{ backgroundColor: '#fffafa', '--animate-delay': delay2 }}
      className={classNames(classes.button, animationButton)}
      size="md"
      // disabled={!loaded || googleFail || loading}
      disabled={googleFail || loading}
      onClick={onClick}
    >
      <div className={classes.oauthButton}>
        <div className={classes.oauthButtonLeft}>
          <img
            src={logo}
            className={classNames(classes.logo, animationEnter)}
            style={{ '--animate-delay': delay1 }}
            alt="website logo"
          />
          {children}
        </div>
        {loading && !googleFail && (
          <Spinner animation="border" className={classes.spinner} />
        )}
      </div>
    </Button>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid white',
  },
  button: {
    width: '100%',
    // backgroundColor: "#fffafa",
    textAlign: 'left',
    // marginBottom: '0px !important;',
    // boxShadow: `0px 2px px #777`,
  },
  oauthButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  oauthButtonLeft: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  logo: {
    height: 28,
    width: 28,
    marginRight: layoutDefaults.smallHorizontalMargin,
    // border: "1px solid red",
  },
  spinner: {
    color: layoutDefaults.secondaryColor,
    fontSize: layoutDefaults.fontSize,
    height: 26,
    width: 26,
  },
});

export { OAuthGoogleButtonContent };
